import InitColorSchemeScript from '@mui/material/InitColorSchemeScript';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { Suspense } from 'react';

import { Loading } from '#components/loading.js';
import { GenericErrorBoundary } from '#screens/error-boundaries/generic-error-boundary.js';
import { colorSchemeSelector, theme } from './theme.js';

import type { ReactNode } from 'react';

export type StyleProvidersProps = {
	children: ReactNode;
};

export function StyleProviders({ children }: StyleProvidersProps) {
	return (
		<StyledEngineProvider enableCssLayer>
			<ThemeProvider theme={theme} noSsr>
				<LocalizationProvider dateAdapter={AdapterDateFns}>
					<InitColorSchemeScript attribute={colorSchemeSelector} />

					<GenericErrorBoundary>
						<Suspense fallback={<Loading />}>{children}</Suspense>
					</GenericErrorBoundary>
				</LocalizationProvider>
			</ThemeProvider>
		</StyledEngineProvider>
	);
}
